<template>
    <section id="MyAccount" class="my-account">

        <div class="cv-rounded mb-5">
            <div class="w-100 d-md-none">
                <img src="https://placehold.co/600x350/00B04E/ffffff?text=Mi+cuenta" alt="Placeholder"
                    class="img-fluid w-100">
            </div>

            <div class="w-100 d-none d-md-block d-lg-none">
                <img src="https://placehold.co/700x250/00B04E/ffffff?text=Mi+cuenta" alt="Placeholder"
                    class="img-fluid w-100">
            </div>

            <div class="w-100 d-none d-lg-block">
                <img src="https://placehold.co/1920x300/00B04E/ffffff?text=Mi+cuenta" alt="Placeholder"
                    class="img-fluid w-100">
            </div>
        </div>

        <template v-if="isLogged">

            <b-row class="limit-width">

                <!-- USER COLUMN -->
                <b-col cols="12" lg="4">
                    <!-- Avatar y nombre de usuario -->
                    <div class="rounded-circle overflow-hidden mx-auto mb-4" style="width: 200px; height: 200px;">
                        <img :src="`https://placehold.co/512x512/00B04E/ffffff?text=${authGetUser.nombre.charAt(0).toUpperCase()}${authGetUser.apellidos.charAt(0).toUpperCase()}`"
                            :alt="`${authGetUser.nombre} ${authGetUser.apellidos}`" class="img-fluid w-100">
                    </div>

                    <!-- Visualización de datos rápidos de cuenta -->
                    <div class="text-center limit-width">
                        <h5 class="text-uppercase">{{ authGetUser.nombre }} {{ authGetUser.apellidos }}</h5>
                        <hr>
                        <h6>{{ authGetUser.email }}</h6>
                    </div>

                    <!-- Bienvenida práctica -->
                    <div class="limit-width mt-4 mb-4 text-center">
                        <div class="alert alert-info" role="alert">
                            <h4 class="alert-heading">¡Bienvenido!</h4>
                            <p class="mb-0">
                                Bienvenido a tu cuenta de Clave Verde. Aquí puedes gestionar tu información personal y
                                acceder a los
                                servicios disponibles.
                            </p>
                        </div>
                    </div>
                </b-col>

                <!-- DATA COLUMN -->
                <b-col cols="12" lg="8">

                    <!-- Tabs -->
                    <b-tabs v-model="activeTab" content-class="mt-2" class="mb-5">

                        <b-tab :title="sectionMyLines.label">

                            <!-- Move the loading and lines content inside the first tab -->
                            <!-- Líneas de teléfono -->
                            <loading v-if="isLoading" />

                            <div class="my-4" v-else>
                                <msisdn-viewer v-for="line in myLines" :key="line.msisdn" :msisdn="line.msisdn"
                                    :alias="line.alias" 
                                    :totalDisponible="line.details.data.availableMb"
                                    :registros="line.details.data.registers"
                                    :fechaCorteMensual="line.details.data.latestExpirationDate"
                                    :porcentajeDisponible="line.details.data.availablePercent" />
                            </div>

                        </b-tab>

                        <b-tab :title="secitonMyPM.label">
                            <!-- <p class="text-center text-muted my-4">Contenido de métodos de pago</p> -->
                            <metodosPagoStripe class="mt-3" />
                        </b-tab>

                        <b-tab :title="secitonAccountHandling.label">
                            <mis-datos />
                        </b-tab>

                        <!-- <b-tab title="Mi historial de compra">
                            <p class="text-center text-muted">Contenido de historial de compra</p>
                        </b-tab> -->
                    </b-tabs>

                </b-col>

            </b-row>

        </template>

        <div class="limit-width text-center" v-else>
            <ui-dotlottie-loader aspect="1:1" lottie="wrong" class="iconify margin-auto mb-3 text-muted" />
            <p>Por favor, inicia sesión para ver los detalles de tu cuenta.</p>
        </div>

    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { notify } from '@/utils';
import axios from 'axios';

import misDatos from '../components/mis-datos.vue';
import msisdnViewer from '../components/msisdn-viewer.vue';

const sectionMyLines = { label: 'Mis líneas', key: 'mis-lineas' },
    secitonMyPM = { label: 'Mis métodos de pago', key: 'mis-metodos-de-pago' },
    secitonAccountHandling = { label: 'Ajustes de cuenta', key: 'ajustes-de-cuenta' },
    secctionNavOrder = [
        sectionMyLines,
        secitonMyPM,
        secitonAccountHandling
    ];

export default {
    name: "MyAccount",
    components: {
        msisdnViewer,
        misDatos
    },
    computed: {
        ...mapGetters(['isLogged', 'authGetUser'])
    },
    data: () => {
        return {
            // TABS CONFIG
            sectionMyLines, secitonMyPM, secitonAccountHandling,
            activeTab: 0,

            // LAODING
            isLoading: false,

            // INNER CONTENT
            myLines: []
        }
    },
    methods: {
        async getMine() {
            this.isLoading = true;

            try {
                const response = await axios.get('index.php?r=claveverde/mydn/default');
                if (response.msg)
                    notify(response.msg, response.class);
                if (response.status) {
                    this.myLines = response.data.myLines;
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoading = false;
            }
        }
    },
    watch: {
        activeTab(newVal, prevVal) {
            if(newVal !== prevVal)
                this.$router.replace({ params: { ...this.$route.params, section: secctionNavOrder[newVal].key } });
        }
    },
    mounted() {
        if (this.isLogged) {
            this.getMine();
        }
    },
    beforeMount() {
        const sectionParam = this.$route.params.section;
        const sectionIndex = secctionNavOrder.findIndex(section => section.key === sectionParam);
        if (sectionIndex !== -1) {
            this.activeTab = sectionIndex;
        }
    }
};
</script>

<style lang="scss">
@import '@/scss/app.scss';

#MyAccount, .my-account {
    .iconify {
    }
}
</style>